import React from "react";
import { Link } from "gatsby";

import styles from "../assets/styles/PortalButton.module.scss";

const PortalButton = ({ to, headline, image, type, price, description }) => {
	let className = styles.root;
	if (type === "large") className += ` ${styles.large}`;

	let dom = (
		<Link to={to} className={styles.link}>
			<img className={styles.image} src={image} alt="" />
			<div className={styles.headline}>
				<p>{headline}</p>
			</div>
		</Link>
	);
	if (type === "disabled")
		dom = (
			<div className={styles.link}>
				<img className={styles.image} src={image} alt="" />
				<div className={styles.headline}>
					<p>{headline}</p>
				</div>
				<div className={styles.overlay}>
					<div>
						<p className={styles.price}>{price}</p>
						<p> per month (incl. VAT)</p>
					</div>
				</div>
			</div>
		);

	return <div className={className}>{dom}</div>;
};

export default PortalButton;
